import React from 'react';
import * as styles from './ImportFileProgress.module.scss';

interface ImportFileProgressProps {
  message: string;
  progress: number;
}

const ImportFileProgress = ({ message, progress }: ImportFileProgressProps) => (
  <div className={styles.container}>
    <div className={styles.progressBarContainer}>
      <div className={styles.progressBar} style={{ width: `${progress}%` }} />
    </div>
    {message} · <strong>{Math.floor(progress)}</strong>%
  </div>
);

export default ImportFileProgress;
